import React, { Component } from 'react';

import "./CreditOption.scss"

class CreditOption extends Component {
    render() {
        return (
            <option value={this.props.item.value}>{this.props.item.name}</option>
        );
    }
}

export default CreditOption;



// WEBPACK FOOTER //
// ./src/components/Creditor/components/CreditOption/CreditOption.js